export default __webpack_public_path__ + "static/1-450fc9f10b143afccb2c977b0df0ee45.jpg";